module.exports = __webpack_public_path__ + "static/media/hands_20.9f79158c.svg";